export const useCdn = (url: MaybeRef<string>) => {
  const config = useRuntimeConfig();

  if (!url) {
    return unref(url);
  }

  const _url = unref(url).replace(/^\/|\/$/g, '');

  return `${config.public.cdnUrl}/${_url}`;
};
